export const showColumnOptions = [
  { name: 'Total Only', value: 'total_only' },
  { name: 'Day', value: 'day' },
  { name: 'Week', value: 'week' },
  // { name: 'Half Month', value: 'half-month' },
  { name: 'Month', value: 'month' },
  { name: 'Quarter', value: 'quarter' },
  { name: 'Year', value: 'year' },
];
